import { RegisterFormErrors, RegisterPayload } from "src/library/types/types";

export const initialFormData: RegisterPayload = {
  agreeReceiveEmail: false,
  campaignSubscribe: 1, // this describes the subscription to Hackathon 2022
  // comment: "",
  components: "{}", // stringified json
  // phone: "",
  organisation: "",
  email: "",
  entryType: 0,
  fingerprint: "",
  name: "",
  location: 2,
  // preferName: "",
  recaptchaResponse: "",
  // ref: "",
  stream: [],
  // teamName: "",
};

export const initialFormErrors: RegisterFormErrors = {
  phone: "",
  email: "",
  entryType: "",
  name: "",
  organisation: "",
  location: "",
};

export const initialGlobalState = {
  registrationsAvailable: true,
  formData: initialFormData,
};
